module.exports = {"id":"142902","name":"Andriy Pyatov","rating":"79","photo":"./data/images/photos/0/142902.png","club":{"name":"Chakhtar Donetsk","logo":"./data/images/clubs/ChakhtarDonetsk.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndriyPyatov0.json
// module id = 403
// module chunks = 0